// src/components/TermsAndConditions.jsx
import React from "react";
import "./TermsAndConditions.css";

const TermsAndConditions = ({ isOpen, onClose, onAcknowledge }) => {
  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>Terms & Conditions</h2>
          <button
            className="terms-close-btn"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        <div className="terms-modal-body">
          <section className="terms-section">
            <h3>Terms and Conditions</h3>
            <ul>
              <li>
                All refunds will be processed 30 days after the completion of
                the conference.
              </li>

              <li>Registration cannot be transferred to any other person.</li>
              <li>
                Organizer will not be responsible for any mailers or information
                delivery failure in case the registration form is not.
              </li>
            </ul>
          </section>
          <div className="terms-acceptance-notice">
            <p>
              <strong>Important:</strong> By proceeding with registration, you
              acknowledge that you have read, understood, and agree to abide by
              all the terms and conditions mentioned above.
            </p>
          </div>
        </div>

        <div className="terms-modal-footer">
          <button
            className="btn btn-primary"
            onClick={() => {
              if (onAcknowledge) {
                onAcknowledge();
              }
              onClose();
            }}
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;